module.exports = __webpack_public_path__ + "static/flags/BN-e8009c23719345a297a974f87e25ca97.gif";